import cs from "./cs/theme.js";
import truecare from "./truecare/theme.js";
import bayou from "./bayou/theme.js";

interface Theme {
    colors: Record<string, object>;
}

const themes: Record<string, Theme> = {
    cs: cs,
    truecare: truecare,
    bayou: bayou,
};

export default function makeTheme(brand = "cs") {
    // Return CS by default
    const theme = themes[brand] ?? themes.cs;

    return {
        ...theme,
        //colorScheme: 'dark',
        breakpoints: {
            xs: "30em",
            sm: "48em",
            md: "64em",
            lg: "74em",
            xl: "80em",
            "2xl": "96em",
        },
        components: {
            Container: {
                defaultProps: {
                    sizes: {
                        xs: "30em",
                        sm: "48em",
                        md: "64em",
                        lg: "74em",
                        xl: "80em",
                        "2xl": "96em",
                    },
                },
            },
        },
        primaryColor: "primary",
    };
}
